import React, { useEffect, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { fetchBuyerStatuses } from '../../actions/statuses';
import { findModules, findUsers, clearUsers } from '../../actions/company/companyTarget';
import { companyInfo } from '../../selectors/targetCompany';
import Popups from '../../components/Popup';

const RetainerHealthPopup = ({ popup }) => {
  const user = popup.getIn(['props', 'user']);

  const dispatch = useDispatch();

  const companyInfoData = useSelector(companyInfo);

  useEffect(() => {
    dispatch(fetchBuyerStatuses());
  }, []);

  /**
   * Find modules by search pattern.
   *
   * @param {string} pattern Search pattern.
   */
  const findModulesByParams = pattern => {
    dispatch(findModules(pattern));
  };

  /**
   * Find users by search pattern.
   *
   * @param {string} pattern Search pattern.
   */
  const findUsersByParams = pattern => {
    dispatch(findUsers(pattern));
  };

  /** Clear users list. */
  const clearUsersList = () => {
    dispatch(clearUsers());
  };

  return (
    <Popups.RetainerHealthPopup
      clearUsers={clearUsersList}
      companyInfoData={companyInfoData}
      findModules={findModulesByParams}
      findUsers={findUsersByParams}
      user={user}
    />
  );
};

export default memo(RetainerHealthPopup);
